<ng-template cdkPortalOutlet></ng-template>
<!--TODO: (AT) When there are no focusable elements on the dialog, will this close it straight away?!? -->
<div tabindex="0" class="cdk-visually-hidden" aria-hidden="true" (focus)="dismiss(1)"></div>